module.exports = __webpack_public_path__ + "img/treasure.e6e97930.png";